import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Observable class extensions
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { CookieService } from 'ngx-cookie';
import { Configuracion } from '../../contants/configuracion.constant';
import { HttpStatus } from '../../enums/http-status';
import { HeaderPeticion } from '../../models/http/headerPeticion.class';




@Injectable()
export class HttpCustom {

  CONTEXT_PATH: string = Configuracion.CONTEXT_PATH;

  constructor(public http: HttpClient,
    private cookieService: CookieService) {
  }

  cargarHeader() {
    let header: HttpHeaders = new HttpHeaders();
    header = header.append('Content-Type', 'application/json')
      .append('Accept', 'application/json; charset=UTF-8')
      .append('X-XSRF-TOKEN', this.getTokenXRSF())
      .append('x-app-relaystate', this.getLocation());

    return header;
  }

  cargarHeadersAdicionales(headers: HeaderPeticion[]) {
    let header = this.cargarHeader();
    if(headers != null) {
      headers.forEach(h => {
        header = header.append(h.nombre, h.valor);
      });
    }

    return header;
  }

  getTokenXRSF(): string {
    return this.cookieService.get(Configuracion.TOKEN_XSRF) !== null
      && this.cookieService.get(Configuracion.TOKEN_XSRF) !== undefined ?
      this.cookieService.get(Configuracion.TOKEN_XSRF) : '';
  }

  getLocation(): string {
    let location: string = window.location.href;
    if (window.location.href.toUpperCase().includes('.COM.PA')) {
      location = Configuracion.CONTEXT_PATH_COTIZADORES + '?country=pa';
    }
    return location;

  }


  getService(url: string, param: {}, context: boolean = true): Observable<any> {

    url = (context ? this.CONTEXT_PATH : '') + url;
    const paramsHttp = param;
    const header = this.cargarHeader();

    return this.http
      .get(url, { headers: header, params: paramsHttp })
      .map((res: Response) => {
        return res;
      })
      .catch((error: any) => {
        return this.handleError(error);
      });

  }

  getServiceWithHeaders(url: string, param: {}, headers: HeaderPeticion[], context: boolean = true): Observable<any> {

    url = (context ? this.CONTEXT_PATH : '') + url;
    const paramsHttp = param;
    const header = this.cargarHeadersAdicionales(headers);
    return this.http
      .get(url, { headers: header, params: paramsHttp })
      .map((res: Response) => {
        return res;
      })
      .catch((error: any) => {
        return this.handleError(error);
      });

  }

  getServiceWithHeadersText(url: string, param: {}, headers: HeaderPeticion[], context: boolean = true): Observable<any> {
    url = (context ? this.CONTEXT_PATH : '') + url;
    const paramsHttp = param;
    const header = this.cargarHeadersAdicionales(headers);
    return this.http
      .get(url, { headers: header, params: paramsHttp, responseType: 'text' })
      .catch((error: any) => {
        return this.handleError(error);
      });
  }


  postService(url: string, param: any): Observable<any> {
    const header = this.cargarHeader();
    url = this.CONTEXT_PATH + url;
    const body = JSON.stringify(param);
    return this.http
      .post(url, body, { headers: header })
      .map((res: Response) => {
        return res;
      })
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  postServiceWithHeaders(url: string, param: any, headers: HeaderPeticion[]): Observable<any> {
    const header = this.cargarHeadersAdicionales(headers);
    url = this.CONTEXT_PATH + url;
    const body = JSON.stringify(param);
    return this.http
      .post(url, body, { headers: header })
      .map((res: Response) => {
        return res;
      })
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  private handleError(error: any): any {
    let errMsg = {};
    if (error.status === HttpStatus.BAD_REQUEST) {
      errMsg = error.error;
    } else {
      errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    }
    return Observable.throw(errMsg);
  }

}




// WEBPACK FOOTER //
// ./src/app/services/http/http-custom.service.ts